import React, { Component } from 'react';
import { Helmet } from 'react-helmet'; // supports <title> tag
import { Grid, Navbar, Jumbotron } from 'react-bootstrap';

import logo from './leaf_embellishmentReverse.svg';
import './App.css';

import MinutesEditor from './MinutesEditor.js';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Helmet>
          <title>Sacred Harp Minutes</title>
        </Helmet>
        <Navbar inverse fixedTop>
          <Grid>
            <Navbar.Header>
              <Navbar.Brand>
                <a href="/">
                  <div style={{ display: 'inline-block' }}>
                    <img src={logo} className="App-logo" alt="logo" />
                  </div>{' '}
                  Minutes
                </a>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
          </Grid>
        </Navbar>
        <Jumbotron>
          <MinutesEditor />
        </Jumbotron>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js